import Login from "../pages/Login"
import { Outlet } from "react-router-dom"
import Page404 from "../pages/Page404"

function RootLayout() {
  return <Outlet />
}

const LoginRoutes = {
  path: "/",
  element: <RootLayout />,
  children: [
    {
      path: "login",
      element: <Login />,
    },
    {
      path: "*",
      element: <Page404 />,
    },
  ],
}

export default LoginRoutes
